import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureUnlock } from '../../hooks/useFeatureUnlock';
import { FeatureName } from '../../types/features';
import BlockedFeatureModal from './BlockedFeatureModal';

interface ProtectedFeatureRouteProps {
  featureName: FeatureName;
  children: React.ReactNode;
  redirectTo?: string;
}

export default function ProtectedFeatureRoute({ 
  featureName, 
  children, 
  redirectTo = '/groups/home-groups' 
}: ProtectedFeatureRouteProps) {
  const { features, loading } = useFeatureUnlock();
  const [showModal, setShowModal] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  const isEnabled = features?.[featureName]?.enabled ?? false;

  useEffect(() => {
    if (!loading && !hasChecked) {
      setHasChecked(true);
      if (!isEnabled) {
        setShowModal(true);
      }
    }
  }, [loading, isEnabled, hasChecked]);

  // Mientras carga, mostrar nada
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
      </div>
    );
  }

  // Si está habilitado, mostrar el contenido
  if (isEnabled) {
    return <>{children}</>;
  }

  // Si está bloqueado, mostrar modal y luego redirigir
  return (
    <>
      <BlockedFeatureModal
        featureName={featureName}
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      />
      {!showModal && <Navigate to={redirectTo} replace />}
    </>
  );
}
